export type ProjectsTab = 'mine' | 'others' | 'archived'

export interface ProjectsNavigationItem {
  id: ProjectsTab
  icon: string
  path: string
  translationKey: string
}

export const PROJECTS_NAVIGATION: ProjectsNavigationItem[] = [
  {
    id: 'mine',
    icon: 'far fa-folder',
    path: '/?tab=mine',
    translationKey: 'HOME:MyProjectsTab',
  },
  {
    id: 'others',
    icon: 'far fa-folder-open',
    path: '/?tab=others',
    translationKey: 'HOME:SharedProyectsTab',
  },
  {
    id: 'archived',
    icon: 'fas fa-archive',
    path: '/?tab=archived',
    translationKey: 'HOME:ArchivedProjectsTab',
  },
]
